module.exports = __webpack_public_path__ + "img/icon-open-case.50251c91.svg";